module.exports = __webpack_public_path__ + "83c34f8359f449f5e7611fe034565e15.svg";